var _linearGradient, _path, _path2, _linearGradient2, _path3, _path4, _path5, _path6, _linearGradient3, _path7, _path8, _linearGradient4, _path9, _linearGradient5, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _linearGradient6, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "strategy_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 513.711,
    y1: 416.494,
    x2: 123.731,
    y2: 107.509,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.8 52.1c-69.1-27-164.8-16.8-217.7 31.5-37.3 34.1-8.4 43.8 17 106.2C182.6 234.9 0 228.7 0 310.3c0 94.3 132.3 76.4 181.3 87.2 75 16.5 140.5 78.2 220.7 70.1 69.8-7.1 96.4-61.9 106.1-124.6 18.1-117-26.3-245.1-143.3-290.9z",
    opacity: 0.25,
    fill: "url(#strategy_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M409.2 126.5h-47v-22.1c0-8.9-10.8-13.4-17.1-7.1L316 126.5H107.2c-11.1 0-20 8.9-20 20v33h-31c-11 0-20 8.9-20 20v200c0 11 9 20 20 20h47v22.1c0 8.9 10.8 13.4 17.1 7.1l29.1-29.1h208.8c11 0 20-9 20-20v-33h31c11 0 20-9 20-20v-200c0-11.2-9-20.1-20-20.1z",
    opacity: 0.11,
    fill: "#2626bc"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "strategy_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 27.206,
    y1: 210.36,
    x2: 552.895,
    y2: 210.36
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M452.5 126.4v200c0 11-9 20-20 20h-302c-11.1 0-20-9-20-20v-200c0-11.1 8.9-20 20-20h208.8l29.1-29.2c6.3-6.3 17.1-1.8 17.1 7.1v22.1h47c11 0 20 9 20 20z",
    fill: "url(#strategy_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.8 311.4v-170c0-2.8 2.2-5 5-5h116.7c2.8 0 5 2.2 5 5v170c0 2.8-2.2 5-5 5H300.8c-2.7 0-5-2.2-5-5zM146.4 311.4v-170c0-2.8 2.2-5 5-5h116.7c2.8 0 5 2.2 5 5v170c0 2.8-2.2 5-5 5H151.4c-2.7 0-5-2.2-5-5z",
    fill: "#d2deff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M401.5 179.4v200c0 11-9 20-20 20H172.7l-29.1 29.1c-6.3 6.3-17.1 1.8-17.1-7.1v-22.1h-47c-11.1 0-20-9-20-20v-200c0-11.1 8.9-20 20-20h302c11 .1 20 9 20 20.1z",
    fill: "#ffaf10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M401.5 179.4v179h-271c-17.6 0-32-14.4-32-32v-167h283c11 0 20 8.9 20 20z",
    fill: "#94b5dd"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "strategy_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 62.5,
    y1: 252.897,
    x2: 661.664,
    y2: 252.897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M401.5 179.4v167h-271c-11.1 0-20-9-20-20v-167h271c11 0 20 8.9 20 20z",
    fill: "url(#strategy_svg__c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205 321.2h-57.9c-2.8 0-5-2.2-5-5v-57.9c0-2.8 2.2-5 5-5H205c2.8 0 5 2.2 5 5v57.9c0 2.7-2.2 5-5 5z",
    fill: "#94b5dd"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "strategy_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 174.972,
    y1: 310.315,
    x2: 244.607,
    y2: 310.315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M239.6 315.3H180c-2.8 0-5-2.2-5-5s2.2-5 5-5h59.6c2.8 0 5 2.2 5 5s-2.2 5-5 5z",
    fill: "url(#strategy_svg__d)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "strategy_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 202.198,
    y1: 291.909,
    x2: 244.607,
    y2: 291.909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M239.6 296.9h-32.4c-2.8 0-5-2.2-5-5s2.2-5 5-5h32.4c2.8 0 5 2.2 5 5s-2.2 5-5 5z",
    fill: "url(#strategy_svg__e)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M432.5 101.4h-42V84.3c0-6.2-3.5-11.5-9.3-13.9-5.7-2.4-12-1.1-16.4 3.3l-27.7 27.7H130.5c-13.8 0-25 11.2-25 25v28h-26c-13.8 0-25 11.2-25 25v200c0 13.8 11.2 25 25 25h42v17.1c0 6.2 3.5 11.5 9.3 13.9 1.9.8 3.9 1.2 5.8 1.2 3.9 0 7.6-1.5 10.5-4.4l27.7-27.7h139.5c2.8 0 5-2.2 5-5s-2.2-5-5-5H172.7c-1.3 0-2.6.5-3.5 1.5L140 425c-2.2 2.2-4.7 1.4-5.4 1.1-.7-.3-3.1-1.5-3.1-4.6v-22.1c0-2.8-2.2-5-5-5h-47c-8.3 0-15-6.7-15-15v-200c0-8.3 6.7-15 15-15h302c8.3 0 15 6.7 15 15v162h-266c-8.3 0-15-6.7-15-15V187.5c0-2.8-2.2-5-5-5s-5 2.2-5 5v138.9c0 13.8 11.2 25 25 25h266v28c0 8.3-6.7 15-15 15h-39.1c-2.8 0-5 2.2-5 5s2.2 5 5 5h39.1c13.8 0 25-11.2 25-25v-28h26c13.8 0 25-11.2 25-25v-200c0-13.8-11.2-25-25-25zm15 225c0 8.3-6.7 15-15 15h-26v-162c0-13.8-11.2-25-25-25h-266v-28c0-8.3 6.7-15 15-15h208.8c1.3 0 2.6-.5 3.5-1.5L372 80.8c2.2-2.2 4.7-1.4 5.5-1.1s3.1 1.5 3.1 4.6v22.1c0 2.8 2.2 5 5 5h47c8.3 0 15 6.7 15 15l-.1 200z",
    fill: "#0046c1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 123.4c-3.7 0-7.5-1.4-10.3-4.3-5.7-5.7-5.7-15 0-20.7 2.8-2.8 6.4-4.3 10.3-4.3s7.6 1.5 10.3 4.3c5.7 5.7 5.7 15 0 20.7-2.8 2.9-6.6 4.3-10.3 4.3zm0-19.2c-1.2 0-2.4.5-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5 1.8 1.8 4.7 1.8 6.5 0 1.8-1.8 1.8-4.7 0-6.5-.8-.8-2-1.3-3.2-1.3zM224.3 447.4c-3.7 0-7.5-1.4-10.3-4.3-5.7-5.7-5.7-15 0-20.7 5.7-5.7 15-5.7 20.7 0 5.7 5.7 5.7 15 0 20.6-3 3-6.7 4.4-10.4 4.4zm0-19.2c-1.2 0-2.4.4-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5 1.8 1.8 4.7 1.8 6.5 0 1.8-1.8 1.8-4.7 0-6.5-.9-.8-2.1-1.3-3.2-1.3z",
    fill: "#8399fe"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260 474.6c-3.7 0-7.5-1.4-10.3-4.3-5.7-5.7-5.7-15 0-20.6s15-5.7 20.7 0c2.8 2.8 4.3 6.4 4.3 10.3s-1.5 7.6-4.3 10.3c-2.9 2.8-6.7 4.3-10.4 4.3zm0-19.2c-1.2 0-2.4.4-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5 1.8 1.8 4.7 1.8 6.5 0 .9-.9 1.3-2 1.3-3.3s-.5-2.4-1.3-3.3c-.8-.8-2-1.2-3.2-1.2zM82.7 61.7h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3V75c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.2-5-5-5z",
    fill: "#01eca5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M427.3 407.8H424v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.2-5-5-5z",
    fill: "#ff7eb8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.6 316.1c-.8 0-1.5-.2-2.3-.6a5.02 5.02 0 01-2.2-6.7c.5-1 13.3-25.5 41.8-51.1 26.3-23.6 71.5-52.4 137.5-55.8 2.8-.2 5.1 2 5.3 4.7.1 2.8-2 5.1-4.7 5.3-63.1 3.3-106.3 30.8-131.3 53.3-27.1 24.3-39.4 48-39.6 48.2-1 1.7-2.7 2.7-4.5 2.7zM345.7 223.3c-1.3 0-2.6-.5-3.5-1.5-2-2-2-5.1 0-7.1l8.2-8.2-8.2-8.2c-2-2-2-5.1 0-7.1s5.1-2 7.1 0L361 203c2 2 2 5.1 0 7.1l-11.8 11.8c-1 .9-2.2 1.4-3.5 1.4z",
    fill: "#d2deff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.9 276.9c-10.5 0-19-8.5-19-19s8.5-19 19-19 19 8.5 19 19-8.6 19-19 19zm0-28c-5 0-9 4.1-9 9 0 5 4 9 9 9s9-4 9-9-4.1-9-9-9zM274 276.9c-10.5 0-19-8.5-19-19s8.5-19 19-19 19 8.5 19 19-8.5 19-19 19zm0-28c-5 0-9 4.1-9 9 0 5 4 9 9 9s9-4 9-9-4-9-9-9z",
    fill: "#ffd18d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329.9 302.1l6.6-6.6c2-2 2-5.1 0-7.1s-5.1-2-7.1 0l-6.6 6.6-6.6-6.6c-2-2-5.1-2-7.1 0s-2 5.1 0 7.1l6.6 6.6-6.6 6.6c-2 2-2 5.1 0 7.1 1 1 2.3 1.5 3.5 1.5s2.6-.5 3.5-1.5l6.6-6.6 6.6 6.6c1 1 2.3 1.5 3.5 1.5 1.3 0 2.6-.5 3.5-1.5 2-2 2-5.1 0-7.1l-6.4-6.6zM221.9 199.3l6.6-6.6c2-2 2-5.1 0-7.1s-5.1-2-7.1 0l-6.6 6.6-6.6-6.6c-2-2-5.1-2-7.1 0s-2 5.1 0 7.1l6.6 6.6-6.6 6.6c-2 2-2 5.1 0 7.1 1 1 2.3 1.5 3.5 1.5 1.3 0 2.6-.5 3.5-1.5l6.6-6.6 6.6 6.6c1 1 2.3 1.5 3.5 1.5s2.6-.5 3.5-1.5c2-2 2-5.1 0-7.1l-6.4-6.6z",
    fill: "#0046c1"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "strategy_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 137.087,
    y1: 243.895,
    x2: 170.313,
    y2: 243.895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M170.3 238.1c0-9.2-7.5-16.6-16.6-16.6s-16.6 7.5-16.6 16.6c0 4.5 1.8 8.6 4.8 11.6-2.9 3-4.8 7.1-4.8 11.6 0 2.8 2.2 5 5 5s5-2.2 5-5c0-3.6 3-6.6 6.6-6.6s6.6 3 6.6 6.6c0 2.8 2.2 5 5 5s5-2.2 5-5c0-4.5-1.8-8.6-4.8-11.6 3-3 4.8-7.1 4.8-11.6zm-16.6-6.6c3.6 0 6.6 3 6.6 6.6s-3 6.6-6.6 6.6-6.6-3-6.6-6.6 3-6.6 6.6-6.6z",
    fill: "url(#strategy_svg__f)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.06b90265bb914c8ae957dc1db8859337.svg";
export { ForwardRef as ReactComponent };